import { render } from "./ClassesCard3.vue?vue&type=template&id=f213bdb6&scoped=true"
import script from "./ClassesCard3.vue?vue&type=script&lang=js"
export * from "./ClassesCard3.vue?vue&type=script&lang=js"

import "./ClassesCard3.vue?vue&type=style&index=0&id=f213bdb6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f213bdb6"]])

export default __exports__